import {FuseLoadable} from '@fuse';

export const OperationsConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/apps/readypayonline/Operations',
            component: FuseLoadable({
                loader: () => import('./Operations')
            })
        },
      
       
      

    ]
};

